import React, { useRef } from "react";

import scrollToRef from "../../helpers/scrollToRef";
import useOnSlugMatch from "../../hooks/useOnSlugMatch";

const InlineDocumentArticle = ({
  slug,
  title,
}: {
  readonly slug?: string;
  readonly title?: string;
}) => {
  const ref = useRef(null);

  useOnSlugMatch(slug, () => {
    scrollToRef(ref, 80);
  });

  return (
    <span ref={ref} data-section-slug={slug}>
      {title}
    </span>
  );
};

export default InlineDocumentArticle;
